import React,{useState,useEffect,useRef} from 'react'
import SubHeader from '../../layout/components/SubHeader'
import Searchbar from './subparts/Searchbar'
import ContactList from './subparts/ContactList'
import ConversationList from './subparts/ConversationList'
import Loading from '../../common/Loading'
import { toast } from 'react-toastify';
import smsgatewayService from '../../../services/smsgateway.service';
import { useEyeconxStore } from '../../../store/eyeconxStore'
function Messages() {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchCriteria, setSearchCriteria] = useState('firstName');
    const [users,setUsers] = useState([])
    const [loading,setLoading] = useState(false)
    const [loadingMore,setLoadingMore] = useState(false)
    const [nextCursor,setNextCursor] = useState(null)
    const [hasNext,setHasNext] = useState(false)
    const [selectedUser, setSelectedUser] = useState(null);
    const [chat, setChat] = useState({});
    const [loadConversation,setLoadConversation] = useState(false)
    const [conversationDetails,setConversationDetails] = useState([])
    const [conversationDetailsLoading,setConversationDetailsLoading] = useState(false)
    const isMounted = useRef(false); // ref to track if the component is mounted
    const clinicId = useEyeconxStore(state => state.user.clinicId)
    const clinicInfo = useEyeconxStore(state => state.clinicInfo)

    useEffect(() => {
        // console.log("Function called ")

        if (!isMounted.current) {
            isMounted.current = true;
            getUserList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleRefresh = ()=>{
        setSelectedUser(null)
        setConversationDetails(null)
        setUsers([])
        setNextCursor(null)
        setHasNext(false)
        getUserList(null,10,"")
    }

    const handleDeleteConversation = () => {
        if (!selectedUser) return;

        smsgatewayService.deleteConversation(clinicId, selectedUser)
            .then(res => {
                toast.success("Conversation deleted successfully");
                // Reset and refresh
                handleRefresh();
            })
            .catch(err => {
                toast.error("Error deleting conversation");
            })
    }
    /* other functions */
    const getUserList = (cursor=null,size=10,searchString="")=>{
        console.log("Get User List")
        console.log("Cursor:"+cursor+" Size: "+size+" search String "+searchString)

        // Set loading state based on whether it's initial load or load more
        if (cursor === null) {
            setLoading(true)
        } else {
            setLoadingMore(true)
        }

        smsgatewayService.getInbox(clinicId,searchCriteria,searchString,cursor,size)
            .then(res=>{
                console.log(res.data)
                // Append new users to existing list
                if (cursor === null) {
                    setUsers(res.data.data)
                } else {
                    setUsers((prevUser) => [...prevUser, ...res.data.data])
                }
                setNextCursor(res.data.nextCursor)
                setHasNext(res.data.hasNext)
                setLoading(false)
                setLoadingMore(false)
            })
            .catch(err=>{
                toast.error("Error getting Users");
                setLoading(false)
                setLoadingMore(false)
            })
    }

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const getCurrentTime = () => {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    };
    /* Seach Functions */
    const handleSearchChange = (strSearch) => {
        setUsers([])
        setNextCursor(null)
        setHasNext(false)
        getUserList(null,10,strSearch)
    }
    const handleSearchCriteriaChange = (e) => {
        setSearchCriteria(e.target.value);
    }
    const handleReset = () => {
        setSearchCriteria("firstName")
        setSearchTerm("")
        setUsers([])
        setNextCursor(null)
        setHasNext(false)
        getUserList(null, 10, "")
    }

    /* Contact List Functions */
    const handleUserSelect = (user) => {
        handleConversation(user)
        setSelectedUser(user);
    }
    const handleLoadMore = () => {
        console.log("Load More")
        if (hasNext && !loadingMore) {
            getUserList(nextCursor, 10, "")
        }
    }
    /* Conversation List Functions */
    const handleConversation = (user,pageNo=0,pageSize=30)=>{
        setLoadConversation(true)
        smsgatewayService.getConversation(clinicId,user,pageNo,pageSize)
            .then(res=>{
                console.log(res.data)
                console.log("Sms Chat Data")
                setChat(res.data)
                setLoadConversation(false)
            })
            .catch(err=>{
                toast.error("Error getting Conversation");
                setLoadConversation(false)
            })
    }
    const handleSendMessage = (message,isConfirmationRequired=false) => {
        if (message.trim() === '' || !selectedUser) return;
        //add this message to chat.content array

        const sendNewMessage = {
            "clinicId": clinicId,
            "business": clinicInfo.sms,
            "customer": chat[0].customer,
            "message": message,
            "isConfirmationRequired": isConfirmationRequired
        }

        smsgatewayService.sendMessage(clinicId,sendNewMessage)
            .then(res=>{
                console.log(res.data)
                toast.success("Message Sent")
                const newMessage =  {
                    "business": clinicInfo.sms,
                    "customer": selectedUser,
                    "message": res.data.message,
                    "customerFirstName": chat[0].customerFirstName,
                    "customerLastName": chat[0].customerLastName,
                    "customerDob": chat[0].customerDob,
                    "messageType": "OUTGOING",
                    "status": "ACCEPTED",
                    "modifiedDate": getTodayDate(),
                    "modifiedTime": getCurrentTime()
                }

                //add to top of chat

                setChat(prevChat => [...prevChat,newMessage])
            })
            .catch(err=>{
                toast.error("Error sending Message");
            })

    }
    const getConversationDetails = (conversationId) => {
        setConversationDetailsLoading(true)
        smsgatewayService.getConversationDetails(clinicId,selectedUser)
            .then(res=>{
                setConversationDetails(res.data)
                // console.log("Conversation Details : ")
                // console.log(res.data)
                setConversationDetailsLoading(false)
            })
            .catch(err=>{
                toast.error("Error getting Conversation Details");
                setConversationDetailsLoading(false)
            })
    }

    return (
        <>
            <SubHeader title="Messages" description={"Communicate with patients using SMS"}>
                <button
                    className='btn btn-light-primary btn-sm rounded-pill'
                    onClick={handleRefresh}
                    title="Refresh messages"
                >
                    <i className="bi bi-arrow-clockwise me-1"></i>
                    Refresh
                </button>
            </SubHeader>
            <div className='container-fluid px-4 py-3'>
                <div className="row g-3">
                    {/* Left Sidebar - Contact List */}
                    <div className="col-12 col-lg-4 col-xl-4">
                        <div className="card shadow-sm border-0" style={{ height: 'calc(100vh - 200px)' }}>
                            <div className="card-body p-3 d-flex flex-column h-100" style={{ overflow: 'hidden' }}>
                                <Searchbar
                                    handleSearchChange={handleSearchChange}
                                    searchCriteria={searchCriteria}
                                    handleSearchCriteriaChange={handleSearchCriteriaChange}
                                    searchTerm={searchTerm}
                                    handleReset={handleReset}
                                />
                                {loading ? (
                                    <Loading />
                                ) : (
                                    <ContactList
                                        users={users}
                                        handleUserSelect={handleUserSelect}
                                        selectedUser={selectedUser}
                                        handleLoadMore={handleLoadMore}
                                        hasNext={hasNext}
                                        loadingMore={loadingMore}
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Right Panel - Conversation */}
                    <div className="col-12 col-lg-8 col-xl-8">
                        {selectedUser ? (
                            <>
                                {loadConversation ? (
                                    <div className="card shadow-sm border-0 d-flex align-items-center justify-content-center" style={{ height: 'calc(100vh - 200px)' }}>
                                        <Loading />
                                    </div>
                                ) : (
                                    chat && (
                                        <ConversationList
                                            smsData={chat}
                                            handleSendMessage={handleSendMessage}
                                            getConversationDetails={getConversationDetails}
                                            conversationDetails={conversationDetails}
                                            conversationDetailsLoading={conversationDetailsLoading}
                                            handleDeleteConversation={handleDeleteConversation}
                                        />
                                    )
                                )}
                            </>
                        ) : (
                            <div className="card shadow-sm border-0" style={{ height: 'calc(100vh - 200px)' }}>
                                <div className="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                    <div className="bg-light rounded-circle p-4 mb-4">
                                        <i className="bi bi-chat-square-text text-primary" style={{fontSize: '3rem'}}></i>
                                    </div>
                                    <h5 className="text-dark fw-semibold mb-2">Select a conversation</h5>
                                    <p className="text-muted mb-0">Choose a contact from the list to start messaging</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Messages